<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="less">
</style>

<script>

export default {
  name: 'AppVue',
  components: {},
  data() {
    return {
      scrollTop: 0,
    };
  },
  mounted() {
  },
  computed: {},
  methods: {},

};
</script>
